export const Logout = async () => {
  const token = localStorage.getItem("token");
  if (token) {
    localStorage.removeItem("token");
    return true;
  } else {
    return false;
  }
};
